import type { ReactNode } from 'react';

import './vazio.css';

export type PropsVazio = {
  titulo: string;
  descricao?: string;
  /** Normalmente um `Botao`: a saída do estado vazio. */
  acao?: ReactNode;
  /** Ilustra o título; nunca o substitui. Ver a nota no corpo. */
  icone?: ReactNode;
  /** Sobe o título de parágrafo a cabeçalho. Ver a nota no corpo. */
  nivel?: 1 | 2;
  className?: string;
};

export function Vazio({
  titulo,
  descricao,
  acao,
  icone,
  nivel,
  className,
}: PropsVazio) {
  /* O título nasceu parágrafo porque o nível certo depende de quem o coloca, e
     um `h2` fixo furaria a hierarquia de um bloco montado fundo na tela — é o
     caso da lista vazia e da `Salvaguarda`. As telas de estado inteiro
     (trancada, 404, falha) são o caso oposto: ali o `Vazio` **é** a página, e
     um parágrafo deixaria a tela sem cabeçalho nenhum para o VoiceOver
     percorrer. `nivel` é essa segunda situação, dita em voz alta; sem ele
     nada muda para os três usos que já existiam. */
  const Titulo = nivel === undefined ? 'p' : nivel === 1 ? 'h1' : 'h2';
  return (
    <div
      className={className ? `ds-vazio ${className}` : 'ds-vazio'}
      /* O mesmo sinal que sobe o título governa a largura da ação: num bloco
         embutido o botão tem o tamanho do seu rótulo, e numa tela que é toda
         o estado ele ocupa a linha, como as pranchas 12.1, 14.3 e 15.3. */
      data-tela={nivel === undefined ? undefined : ''}
    >
      {/* `aria-hidden` no invólucro, e não só no `<svg>`: o ícone ilustra o
          que o título já diz, e anunciá-lo faria ler duas vezes o mesmo
          estado. */}
      {icone ? (
        <span className="ds-vazio__icone" aria-hidden="true">
          {icone}
        </span>
      ) : null}
      <Titulo className="ds-vazio__titulo">{titulo}</Titulo>
      {descricao ? <p className="ds-vazio__descricao">{descricao}</p> : null}
      {acao ? <div className="ds-vazio__acao">{acao}</div> : null}
    </div>
  );
}
